import { LocationReducerForLocale, LocationsReducer } from './Locations.reducer';

export const reducer = {
  allLocations: LocationsReducer,
  locationForLocale: LocationReducerForLocale,
};
